import { render, staticRenderFns } from "./categories-tree.vue?vue&type=template&id=7f9a9174&"
import script from "./categories-tree.vue?vue&type=script&lang=js&"
export * from "./categories-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports